import { Routes, Route } from "react-router-dom";
import { useEffect, useState } from "react";
import Layout from "./export/Layout";

//HOME//
// import ButtonGradient from "./assets/svg/ButtonGradient";
import Benefits from "./components/Benefits";
import Collaboration from "./components/Collaboration";
import Hero from "./components/Hero";
import Portfolio from "./components/Portfolio";
import Roadmap from "./components/Roadmap";
import Services from "./components/Services";
import Contact from "./components/Contact";
import NotFound from "./components/NotFound";
//BLOG//
// import { blogs } from "../.velite/generated";

import BlogPage from "./export/blogs/page";
import CategoryPage from "./export/categories/page";
import RecentPosts from "./export/RecentPosts";

import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsAndConditions from "./components/TermsAndConditions";

//
import AiCall from "./pages/AiCall";
// Admin Components
// import AdminLogin from "./pages/AdminLogin";
// import AdminDashboard from "./pages/AdminDashboard";

// Home Component
const Home = () => {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    // Fetch the blogs.json file
    fetch("/blogs/blog.json")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => setBlogs(data))
      .catch((error) => console.error("Error fetching blogs:", error));
  }, []);

  return (
    <div className="overflow-hidden pt-[4.75rem] lg:pt-[5.25rem]">
      <title>Bafar Labs: AI, Software, Web & Digital Marketing Solutions</title>
      <meta
        name="title"
        content="Bafar Labs: AI, Software, Web & Digital Marketing Solutions"
      />
      <link rel="canonical" href="https://www.bafarlabs.com/" />
      <meta
        name="description"
        content="Bafar Labs (BafarLabs) offers software, web, and digital solutions, along with AI products like AI Interview and AI Calling Agent to help businesses grow and innovate."
      />
      <meta
        name="keywords"
        content="Software Development, AI Solutions, Web Design, Mobile App Development, Digital Marketing, ERP Systems, Business Automation, Bafar Labs, BafarLabs, AI Mock Interviews, AI Solutions"
      />
      <meta name="robots" content="index, follow"></meta>
      <link rel="preload" href="./assets/gpt5-GjnNDSsl.webp" as="image" />
      <Hero />
      <Roadmap />
      <Collaboration />
      <Benefits />
      <Portfolio />
      <Services />
      <RecentPosts blogs={blogs} />
      <Contact />
      {/* <ButtonGradient /> */}
    </div>
  );
};

// Main App Component
const App = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route
        path="/"
        element={
          <Layout>
            <Home />
          </Layout>
        }
      />
      <Route
        path="/privacy-policy"
        element={
          <Layout>
            <PrivacyPolicy />
          </Layout>
        }
      />
      <Route
        path="/terms-and-conditions"
        element={
          <Layout>
            <TermsAndConditions />
          </Layout>
        }
      />
      <Route
        path="/ai-calling-agent"
        element={
          <Layout>
            <AiCall />
          </Layout>
        }
      />
      <Route
        path="/blogs/:slug"
        element={
          <Layout>
            <BlogPage />
          </Layout>
        }
      />
      <Route
        path="/blog-categories/:slug"
        element={
          <Layout>
            <CategoryPage />
          </Layout>
        }
      />

      <Route
        path="*"
        element={
          <Layout>
            <NotFound />
          </Layout>
        }
      />
    </Routes>
  );
};

export default App;
